import {css} from "lit";

// Note that we don't use variables in some places because these are external colors/styles.

export default [css`
	button {
		display: flex;
		width: 100%;
		gap: 4px;
		align-items: center;
		text-align: left;
		cursor: pointer;
		
		padding: 0;
		margin: 10px 0 0;
		background: none;
		border: none;
	}

	img {
		width: 20px;
		height: 20px;
	}

	span {
		font-family: Helvetica, Arial, sans-serif;
		font-weight: 400;
		font-size: 13.5px;
		color: rgb(89, 89, 89);
	}

	button:hover span, button:focus span, button:active span {
		text-decoration: underline;
	}
`];
